import { useEffect } from 'react';

// Adds `.in` to every `.reveal` element as it scrolls into view. One observer
// for the whole page — components opt in with the class, nothing else to wire.
function useReveal() {
    useEffect(() => {
        const els = document.querySelectorAll('.reveal');

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
            els.forEach(el => el.classList.add('in'));
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in');
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

        els.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, []);
}

export default useReveal;
